import { useEffect } from 'react';
import { useQuery } from 'react-query';

const useGet = (apiMethodConfig, params = [], shouldFetch = true) => {
  // Validar y normalizar apiMethodConfig
  let apiKey = 'invalid';
  let apiMethod = () => Promise.reject(new Error('Configuración de API inválida'));
  let isValid = false;

  if (apiMethodConfig && Array.isArray(apiMethodConfig) && apiMethodConfig.length >= 2) {
    const [key, method] = apiMethodConfig;
    if (typeof method === 'function') {
      apiKey = key;
      apiMethod = method;
      isValid = true;
    } else {
      console.error('useGet: apiMethod debe ser una función', { key, method, type: typeof method });
    }
  } else {
    console.error('useGet: apiMethodConfig debe ser un array [apiKey, apiMethod]', {
      received: apiMethodConfig,
      type: typeof apiMethodConfig,
      isArray: Array.isArray(apiMethodConfig)
    });
  }

  // Los hooks deben llamarse siempre, sin condiciones
  const {
    // isLoading,
    isFetching,
    isSuccess,
    data: queryData,
    isError,
    error,
    refetch
  } = useQuery(
    [apiKey, ...params],
    queryParams => {
      if (!isValid) {
        return Promise.reject(new Error('Configuración de API inválida'));
      }
      return apiMethod(...queryParams.queryKey.slice(1));
    },
    { enabled: shouldFetch && isValid, retry: 0 }
  );

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      if (error) {
        console.log('GET ERROR', error);
        console.log('GET ERROR RESPONSE', error.response);
      }
    }
  }, [error, queryData]);

  // Si la configuración no es válida, retornar error inmediatamente
  if (!isValid) {
    return {
      isSuccess: false,
      isError: true,
      data: null,
      refetch: () => {},
      isLoading: false,
      errorMessage: 'Configuración de API inválida'
    };
  }

  const localSuccess = isSuccess && queryData?.statusCode === 200;
  let localError = isError || !isValid;
  let data = null;

  if (queryData) {
    data = queryData.body;
    localError = !localSuccess;
  }

  return {
    isSuccess: localSuccess,
    isError: localError,
    data,
    refetch,
    isLoading: isFetching,
    errorMessage: error?.response?.data?.message || error?.response?.data?.body || error?.message || 'Error en la petición'
  };
};

export default useGet;
